// Кнопки блока со ссылками в превью-телефоне. Декоративные, как X и прогресс-бар
// рядом: студия показывает вид слайда, а не проигрывает его — поэтому это div, а не
// `a`, и ссылка автора в DOM не попадает (бек её не валидирует вообще, контракт §2).
// Стиль — ref-вариант `secondary` (DesignBlockEditor.tsx:502-505): приглушённая пилюля,
// не спорит с филлед-CTA под ней и читается поверх full-bleed картинки.
import { blockTheme, hsl } from '@teach/ui'
import type { BlockButton } from '@/types/blocks'
import type { ContentLang } from '@/features/editor/editorSlice'
import { buttonsForLang, DEFAULT_BUTTON_TITLE } from '@/features/editor/lib/blockButtons'

interface Props {
  buttons: BlockButton[] | undefined
  contentLang: ContentLang
}

export const BlockLinkButtons = ({ buttons, contentLang }: Props) => {
  const items = buttonsForLang(buttons, contentLang)
  if (!items.length) return null

  return (
    <div className="flex flex-col items-center gap-2 pb-2">
      {items.map((button, index) => (
        <div
          // Кнопки не имеют стабильного идентификатора: бек пересоздаёт их на каждом
          // сохранении блока (§5). В превью список не редактируется — DOM-состояния,
          // которое сместилось бы, тут нет.
          key={index}
          className="w-full max-w-md truncate rounded-full px-4 py-2.5 text-center text-sm font-semibold"
          style={{
            backgroundColor: hsl(blockTheme.muted),
            color: hsl(blockTheme.foreground),
          }}
        >
          {button.title?.trim() || DEFAULT_BUTTON_TITLE}
        </div>
      ))}
    </div>
  )
}
